import commonZhHK from './common_zh-HK'

const componentZhHK = {
  component: {
    ...commonZhHK,
  }
}

export default componentZhHK